module.exports = __webpack_public_path__ + "img/daffodil-large-graphic.d685bea9.svg";